import { createPlanEditRegistry } from './plan_edit_session.mjs';
// Registering a product does not activate keyboard handlers or edit any project.
const registry = createPlanEditRegistry();
export const registerPlanEditProvider = registry.register;
export const unregisterPlanEditProvider = registry.unregister;
export const createPlanEditSession = registry.createSession;

export const createPlanInteractionSession = registry.createInteractionSession;
